const Footer = () => {

    return (
        <footer className="footer">
            <a href="https://www.jonahlmadeya.com" target="_blank" rel="noopener noreferrer">
                Made with ❤️ by Jonah
            </a>
        </footer>
    )
};

export default Footer;